/** Width for filter-field dropdown menus (invitee email, event types, packages, etc.). */
export const FILTER_FIELD_DROPDOWN_WIDTH = 520;

/** Width for the meetings date-range picker dropdown (calendar + bookmarks). */
export const DATE_RANGE_DROPDOWN_WIDTH = 620;

// From React-Aria popover styles
export const PORTALED_MENU_Z_INDEX = 100000;

/**
 * Applied to `#meetings-filter-menu-portal` so portaled menus stack above the FilterMenu popover.
 */
export const portaledMenuPortalRootCss = "p1i99d80";

/**
 * Scope Select popovers portal to document.body; lift them above the full-screen filter sheet.
 * Must use a top-level :global() block — nested :global() under a local class does not match body.
 */
export const meetingsFilterScopePopoverGlobalCss = "mmff9wc";
export const portaledMenuShellCss = "p4hql0j";

/**
 * CUI ProTip portals to document.body via useFloating (z-index 25). Meetings filter/settings
 * menus portal to #meetings-filter-menu-portal at PORTALED_MENU_Z_INDEX + 1, which covers the tip.
 * Lift ProTip layers while any portaled filter-dropdown menu is mounted in that portal.
 */
export const meetingsPortaledMenuProTipGlobalCss = "m1om9c3";
export const filterFieldDropdownMenuCss = "f1g83jie";
export const dateRangeDropdownMenuCss = "dly6j6b";

/**
 * Phone date picker scroll shell. CUI's mobile RangeCalendar navigates months via
 * scrollIntoView; the scroll container must be this fixed shell, not an inner panel
 * with overflow: hidden (see Container in dropdown/styles.js).
 */
export const dateRangeDropdownScrollShellCss = "d19u1or";

/** Inner menu chrome on phone — scrolling is handled by dateRangeDropdownScrollShellCss. */
export const dateRangeDropdownMenuPhoneCss = "d7ngi4d";

require("./portaled_menu_styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./portaled_menu_styles.js");